
export const HeartbeatActionTypes = {
    Invoke: "Heartbeat_Invoke",
    OnHeartbeat: "Heartbeat_OnHeartbeat",
    OnHeartbeatError: "Heartbeat_OnHeartbeatError",
    OnHeartbeatMaxErrors: "Heartbeat_OnHeartbeatMaxErrors"
};

const httpCall = async (method, api, body) => fetch(api, {
    body: body,
    method: method,
    credentials: "include"
});

export const redirectToLogin = () => window.location = "/trp/auth/login";

export const redirector = (fetchCall) => fetchCall.then(response => {
    if (response.status === 401) {
        redirectToLogin();
    } else {
        return Promise.resolve(response);
    }
});

export const heartbeat = async () => redirector(httpCall("GET", "/trp/auth/heartbeat"));

export const HEARTBEAT_MAX_RETRIES = 3;
export const HEARTBEAT_INTERVAL_MS = 150000;

